<div id="dividersColor" #dividersColorElement></div>
<div id="primaryTextColor" #primaryTextColorElement></div>
<div id="secondaryTextColor" #secondaryTextColorElement></div>
<div id="primaryLighterColor" #primaryLighterColorElement></div>
<div id="primaryColor" #primaryColorElement></div>
<div id="accentLighterColor" #accentLighterColorElement></div>
<div id="accentColor" #accentColorElement></div>
<div id="warnLighterColor" #warnLighterColorElement></div>
<div id="warnColor" #warnColorElement></div>
